<template>
  <div>
     <h3>Material Items</h3>

     <b-row>
       <b-col cols="4">
          <material-item-form />
       </b-col>
       <b-col cols="8">
          <single-material-item v-for="materialItem in materialItems" v-bind:key="materialItem.id" :material="materialItem" />
       </b-col>
     </b-row>

  </div>
</template>

<script>
const MaterialItemForm = () => import(/* webpackChunkName: "stocks.material-item-form" */ "./material-item-form")
const SingleMaterialItem = () => import(/* webpackChunkName: "stocks.single-material-item" */ "./single-material-item");



import MaterialStockService from '../../../../services/material-stock.service';
import EventBus from '../../../../EventBus';

  export default {
     data(){
        return {
           materialItems: []
        }
     },
     mounted(){
        this.fetchAllMaterials()

        EventBus.$on('material-stock.added-or-updated', () => {
            this.fetchAllMaterials()
        })

        EventBus.$on("stocks.deleted-material-stock", (id) => {
            this.materialItems = this.materialItems.filter(material => material.id != id)
        })
     },
     components: {MaterialItemForm, SingleMaterialItem},
     methods: {
        async fetchAllMaterials(){
           try{
              const apiCall = await MaterialStockService.fetchAllMaterials();

              this.materialItems = apiCall.data.materialItems
           }catch(errors){
              console.log(errors)
           }
        }
     },
     beforeDestroy(){
        EventBus.$off('material-stock.added-or-updated')
     }
  }
</script>

<style lang="scss" scoped>

</style>